import React from 'react';
import { ERPSortBy } from '~/libs/infrastructure/schemas/erp';

interface ButtonSortProps {
	sortBy: ERPSortBy;
	onChange: () => void;
	offsetLeft?: number;
}

export const ButtonSort = ({ sortBy, onChange, offsetLeft = 0 }: ButtonSortProps) => {
	return (
		<div className='absolute mt-2 top-px z-10' style={{ marginLeft: offsetLeft }}>
			<div className='relative -ml-px btn-price'>
				<button
					className='h-auto w-auto px-2 py-1 rounded-sm md:text-label text-labelsmall font-display font-medium text-black bg-cEmerald-500 tracking-wide transition hover:text-white hover:bg-cEmerald-800'
					onClick={onChange}
				>
					Sort by {sortBy === ERPSortBy.NAME ? 'Price' : 'Name'}
				</button>
			</div>
		</div>
	);
};
